<template>
  <div id="app">
    <layoutTopbar></layoutTopbar>
    <el-container class="u-flex-col">
      <el-container>
        <layoutAsideAd></layoutAsideAd>
        <slot />
      </el-container>
      <layoutFooter></layoutFooter>
    </el-container>
  </div>
</template> 

<script>
import layoutFooter from '@/components/layout/layout-footer'

import layoutTopbar from '@/components/layout/layout-topbar'
import layoutAsideAd from '@/components/layout/loyout-aside-ad'
import InitMixin from './initMixin'

export default {
  mixins: [InitMixin],
  components: {
    layoutFooter,
    layoutTopbar,
    layoutAsideAd,
  },
}
</script>

<style  scoped="scoped">
 
</style>
